module.exports = __webpack_public_path__ + "img/Exit.70efe711.svg";